import { atom, useAtom } from "jotai";

const isOnboardingAtom = atom(false);

export const useOnboardingAtom = () => useAtom(isOnboardingAtom)